module.exports = __webpack_public_path__ + "img/combosdk14.2aafae8.png";